import { makeStyles } from '@material-ui/core';
import { Colors } from '../../utils';

const makeClasses = makeStyles(theme => ({
    container: {
        width: '100%',
        border: '1px solid',
        borderColor: Colors.rgb.textSoft,
        borderRadius: '10px',
        '& .MuiFormGroup-root': {
            display: 'block'
        }
    },
    labelWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    input: {
        display: 'flex',
        padding: '15px',
        margin: 0,
        borderBottom: '1px solid',
        borderColor: `${Colors.rgb.textSoft} !important`,
        '&:last-of-type': {
            borderBottom: 'none',
        },
    },
    activeInput: {
        borderBottom: 'none',
        position: 'relative',
        '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 55,
            right: 15,      
            height: 1,
            backgroundColor: Colors.rgb.textSoft,
  },
    },
    additionalInputContainer: {
        borderBottom: '1px solid',
        borderColor: `${Colors.rgb.textSoft} !important`,
    },
    additionalInput: {
        marginTop: theme.spacing(3),
        paddingLeft: '3.7rem',
        paddingBottom: '15px',
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    label: {
        fontWeight: 'normal'
    },
    description: {
        fontWeight: 'normal',
        color: Colors.rgb.contentTextSoft,
        fontSize: theme.fontSize.M
    }
}));

export default makeClasses;
